import React, { useState, useContext } from "react";
import { toast } from "react-toastify";
import { useBuySellModalContext } from "../../../context/BuySellModalContext";
import WebsocketWrapperContext from "../../../context/WebsocketWrapperContext";
import CustomToastContent from "../../../components/CustomToastContent";
import MarketDepth from "./MarketDepth";
import InfoIcon from "../../../images/orders/info_icon.svg";
const OrderModal = ({
  order,
  selectedOrders,
  onCancelOrders,
  onClose,
  setIsBuySellModalOpen,
}) => {
  console.log("Selected Order from orders table", order);
  const [isOrderDetailsExpanded, setIsOrderDetailsExpanded] = useState(false);
  const [isMarketDepthExpanded, setIsMarketDepthExpanded] = useState(true);
  const { buySellModalData, setBuySellModalData } = useBuySellModalContext();
  const { symbolData } = useContext(WebsocketWrapperContext);

  // Format date and time similar to the parent component
  const formatDateTime = (dateTimeString) => {
    const dateTime = new Date(dateTimeString);
    const time = dateTime.toLocaleTimeString([], {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
    const date = dateTime.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });

    return `${time}, ${date}`;
  };
  const prepareTradeData = (isModify = false) => {
    const ltpPrice = symbolData[order?.code]?.ltp;
    const dataObject = {
      side: order.side === 1 ? "Buy" : "Sell",
      instrumentName: order.symbol,
      lotSize: order.qty / order.lotSize,
      lot_size: order.lotSize,
      productType: order.productType,
      code: order.code,
      price: order.tradedPrice || 0,
      trigger_price: order.trigger_price || 0,
      buy_sell: order.side === 1 ? "B" : "S",
      tradingSymbol: order.symbol,
      quantity: order.qty,
      exchange: order.exchange,
      orderStatus: order.status,
      scrip: order.scrip,
      isModify: isModify,
      orderType:
        order.orderType.toUpperCase() === "MARKET"
          ? "MARKET"
          : order.trigger_price === "00.00" &&
              order.orderType.toUpperCase() === "LIMIT"
            ? "LIMIT"
            : "TRIGGER",

      ...(isModify && { orderId: order.id }),
    };
    return dataObject; // Directly return the object
  };
  const orderDetails = [
    { title: "Order ID", value: order.id },
    { title: "Order Type", value: order.orderType },
    { title: "Quantity", value: `${order.filledQty}/${order.qty}` },
    {
      title: "Product",
      value: order.productType === "Intraday" ? "MIS" : "NRML",
    },
    { title: "Price", value: order.tradedPrice || order.stopPrice || "Market" },
    {
      title: "Status",
      value: order.status,
    },
    { title: "Order Time", value: order.orderDateTime },
  ];
  const handleModifyClick = () => {
    onClose();
    setBuySellModalData([prepareTradeData(true)]);
    setIsBuySellModalOpen(true);
  };

  const handleRepeatOrder = () => {
    onClose();
    setBuySellModalData([prepareTradeData(false)]);
    setIsBuySellModalOpen(true);
    // console.log("buySellModalData", buySellModalData);
  };

  const handleCancelOrder = async () => {
    await onCancelOrders([order]);
    toast.success(
      <CustomToastContent
        heading="Order cancelled successfully!"
        message="Successfully cancelled order!"
      />,
      {
        className: "custom-success-toast",
        icon: <img src={""} alt="Success Icon" />,
      }
    );
    onClose();
  };

  // LTP
  const LtpWidget = ({ code }) => {
    // console.log("Code:", code);
    // console.log("symbolData[code]:", symbolData[code]);
    const ltpPrice = symbolData[code]?.ltp || 0;
    const pctChange = symbolData[code]?.change_per || 0;
    const changeColor = pctChange >= 0 ? "text-p150" : "text-[#B01431]";
    // console.log("ltpPrice", ltpPrice);

    return (
      <div className="flex items-center">
        <span className="text-xl font-bold text-p300">{ltpPrice}</span>
        <span className={`ml-2 text-xs font-medium ${changeColor}`}>
          {pctChange >= 0 ? "+" : ""}
          {pctChange}%
        </span>
      </div>
    );
  };

  // Order Details component
  const OrderDetailsWidget = ({ order }) => (
    <div className="flex flex-col space-y-3">
      {orderDetails.map((detail, index) => (
        <div key={index} className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="w-1 h-1 rounded-full bg-n500 mr-2 mt-[2px]"></div>
            <p className="text-xs font-medium text-n500">{detail.title}</p>
          </div>
          <div className="ml-12">
            {detail.customRender ? (
              detail.render()
            ) : (
              <p className="text-sm font-medium text-p300">{detail.value}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
  // Determine if we should add the mt-10 class
  const shouldAddMarginTop =
    isMarketDepthExpanded &&
    isOrderDetailsExpanded &&
    order.status === "Rejected";
  return (
    <div className="modal modal-open z-40">
      <div
        className={`modal-box  no-scrollbar bg-modalBg max-w-md p-0 rounded-lg ${shouldAddMarginTop ? "mt-10" : ""}`}>
        {/* Modal Header */}
        <div className="p-4">
          <div className="flex justify-between items-start">
            {/* Symbol & LTP */}
            <div>
              <h3 className="text-sm font-medium text-p300">{order.symbol}</h3>
              <div className="mt-1">
                <LtpWidget code={order.code} />
              </div>
            </div>

            {/* Exchange, Buy/Sell label, and Close button */}
            <div className="flex items-center">
              <div className="bg-n100 rounded-sm px-2 py-1">
                <div className="text-xs font-medium text-n700">
                  {order.exchange}
                </div>
              </div>
              <div
                className={`ml-2 rounded-sm px-2 py-1 ${
                  order.side === 1
                    ? "bg-[#12B16E26] bg-opacity-15 text-p150"
                    : "bg-[#B01431] bg-opacity-15 text-[#B01431]"
                }`}>
                <div className="text-xs font-medium">
                  {order.side === 1 ? "Buy" : "Sell"}
                </div>
              </div>
              <button
                className="ml-4 text-n400 hover:text-n700"
                onClick={onClose}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div className="divider my-0 h-px bg-n200"></div>

        {/* Rejection Message if applicable */}
        {order.status === "Rejected" && (
          <div className="px-4 pt-4 flex items-start">
            <img src={InfoIcon} alt="Info" className="w-5 h-5" />
            <p className="ml-2 text-xs font-medium text-[#E94C69]">
              {order.message}
            </p>
          </div>
        )}

        {/* Order Details Section */}
        <div className="px-4 py-4">
          <button
            className="flex w-full justify-between items-center focus:outline-none"
            onClick={() => setIsOrderDetailsExpanded(!isOrderDetailsExpanded)}>
            <h3 className="text-base font-semibold text-p300 mb-4">
              Order Details
            </h3>
            <span className="text-n400">
              {isOrderDetailsExpanded ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 mb-4"
                  viewBox="0 0 20 20"
                  fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </span>
          </button>

          {isOrderDetailsExpanded && <OrderDetailsWidget order={order} />}
        </div>

        <div className="divider my-0 h-px bg-n200"></div>

        {/* Market Depth Section */}
        <div className="px-4 py-4">
          <button
            className="flex w-full justify-between items-center focus:outline-none"
            onClick={() => setIsMarketDepthExpanded(!isMarketDepthExpanded)}>
            <h3 className="text-base font-semibold text-p300 mb-4">
              Market Depth
            </h3>
            <span className="text-n400">
              {isMarketDepthExpanded ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 mb-4"
                  viewBox="0 0 20 20"
                  fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </span>
          </button>

          {isMarketDepthExpanded && <MarketDepth symbolCode={order.code} />}
        </div>

        <div className="divider my-0 h-px bg-n200"></div>

        {/* Action Buttons based on order status */}
        <div className="p-4">
          {/* {order.status === "Pending" ? (
            <div className="flex gap-2">
              <button
                className="btn flex-1 h-9 min-h-0 border border-p300 bg-p400 text-p300 text-xs font-semibold hover:bg-p400 hover:text-p300 hover:border-p300"
                onClick={handleCancelOrder}>
                Cancel order
              </button>
              <button
                className="btn flex-1 h-9 min-h-0 bg-p300 text-p400 text-xs font-semibold hover:bg-p300 hover:text-p400"
                onClick={handleModifyClick}>
                Modify order
              </button>
            </div>
          ) : ( */}
          <button
            className="btn w-full h-9 min-h-0 bg-swipe-button text-p400 text-xs font-semibold border-none hover:bg-swipe-button"
            onClick={handleRepeatOrder}>
            Repeat Order
          </button>
          {/* )} */}
        </div>
      </div>

      {/* {isBuySellModalOpen && (
        <BuySellModal
          modalOpen={isBuySellModalOpen}
          modalClose={handleBuySellModalClose}
        />
      )} */}
    </div>
  );
};

export default OrderModal;
